import { render, staticRenderFns } from "./BnftTimeCounter.vue?vue&type=template&id=5f20a1bb&scoped=true&"
import script from "./BnftTimeCounter.vue?vue&type=script&lang=js&"
export * from "./BnftTimeCounter.vue?vue&type=script&lang=js&"
import style0 from "./BnftTimeCounter.vue?vue&type=style&index=0&id=5f20a1bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20a1bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VTooltip})
